

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default global options } */)

@Component({
  components: {
    swiper,
    swiperSlide
  },
})
export default class Slider extends Vue {
  @Prop() private products!: Array<any>;

  slidesPerView(){
     return Math.round(window.innerWidth / 400) > this.products.length ? this.products.length : Math.round(window.innerWidth / 400);
  }

  data(): any {
    return {
      swiperOption: {
        slidesPerView: this.slidesPerView(),
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }

}
